
export const companies = [
  { name: 'Toyota', symbol: 'TM' },
  { name: 'Volkswagen', symbol: 'VWAGY' },
  { name: 'Ford', symbol: 'F' }
];
